import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import s1 from "../assets/images_new/ets.webp";
import s2 from "../assets/images_new/airport.webp";
import s3 from "../assets/images_new/shuttle.webp";
import luxury from "../assets/images_new/vip.webp";
import wedding from "../assets/images_new/wedding.webp";

import mice from "../assets/images_new/mice.webp";
const Services = () => {
  return (
    <div>
      <div className="section home-services">
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <div className="main-title text-center">
                <h4>Our Services </h4>
                <div className="divider-center"></div>
              </div>
            </Col>
          </Row>
         
          <Row className="mt-5 gx-4 gy-4">
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={s1} className="img-fluid" alt="logo" />
                <h4>Employee Transportation Services (ETS) </h4>
                
                <p>
                  Hive Employee Transportation And Cab Services has emerged as the leading transport company in Telangana, Hyderabad for Employee Transportation. Since, Hyderabad is the IT hub; employees have different working hours according to the overseas clients’ time zone. 
                </p>
                <Link to="/employee-transportation-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={s2} className="img-fluid" alt="logo" />
                <h4>Airport Transfers </h4>
                <h5>
                  Embark on a Stress-Free Journey with Hive Employee Transportation And Cab Services
                </h5>
                <p>
                  For over 5 years, Hive Employee Transportation And Cab Services has been a pioneer in
                  delivering exceptional airport transfer services throughout
                  India. Our Airport Transfers are meticulously crafted to meet
                  the needs of discerning travellers, ensuring a seamless...
                </p>
                <Link to="/airport-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={s3} className="img-fluid" alt="logo" />
                <h4>Shuttle Services </h4>
              
                <p>
                 Our shuttle service cuts down the challenges of waiting for a bus or negotiating with auto drivers. With our shuttle service, employees can comfortably commute to their workplace. We offer AC and non-AC shuttle services, with a mobile application enabled for tracking.
                </p>
                <Link to="/shuttle-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={mice} className="img-fluid" alt="logo" />
                <h4>MICE and Event Transport </h4>
                <h5>
                  Embark on a Stress-Free Journey with Hive Employee Transportation And Cab Services
                </h5>
                <p>
                  Embark on a seamless journey to success with Hive Employee Transportation And Cab Services' bespoke MICE and Event Transport services.
                  Recognizing the unique demands of every event, whether it's a
                  corporate conference, wedding extravaganza, or cultural
                  festival, we tailor...
                </p>
                <Link to="/our-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={luxury} className="img-fluid" alt="logo" />
                <h4>Luxury and VIP Car-Rental Services </h4>
                <h5>
                  Embark on a Stress-Free Journey with Hive Employee Transportation And Cab Services
                </h5>
                <p>
                  Experience the pinnacle of luxury and VIP treatment with Hive Employee Transportation And Cab Services' exclusive car rental services. We understand
                  that you're not just seeking transportation; you're indulging
                  in an experience of opulence, sophistication, and unparalleled
                  comfort.
                </p>
                <Link to="/our-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={wedding} className="img-fluid" alt="logo" />
                <h4>Wedding Car Rentals </h4>
                <h5>
                  Embark on a Stress-Free Journey with Hive Employee Transportation And Cab Services
                </h5>
                <p>
                  Hive Employee Transportation And Cab Services offers a bespoke wedding car rental
                  service tailored to elevate your special day. With a luxurious
                  fleet of vehicles, professional chauffeurs, and personalized
                  attention to detail, we ensure a seamless...
                </p>
                <Link to="/our-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col>
            {/* <Col xs={12} md={4}>
              <div className="services-card text-center">
                <img src={carpooling} className="img-fluid" alt="logo" />
                <h4>Corporate Carpooling </h4>
                <h5>
                  Embark on a Stress-Free Journey with Hive Employee Transportation And Cab Services
                </h5>
                <p>
                Enjoy hassle-free carpooling with our chauffeur-driven services, ensuring convenience and comfort for every ride.
Avail daily office commute services in our monthly/daily packages

                </p>
                <Link to="/our-services">
                  <Button className="primary-btn">Read More</Button>
                </Link>
              </div>
            </Col> */}
          </Row>

        </Container>
      </div>
    </div>
  );
};

export default Services;
